const NOTES_TYPES = {

    FETCH_NOTES_BY_ENTITY_BEGIN: "FETCH_NOTES_BY_ENTITY_BEGIN",
    FETCH_NOTES_BY_ENTITY_SUCCESS: "FETCH_NOTES_BY_ENTITY_SUCCESS",
    FETCH_NOTES_BY_ENTITY_FAILURE: "FETCH_NOTES_BY_ENTITY_FAILURE",

    CREATE_NOTE_BEGIN: "CREATE_NOTE_BEGIN",
    CREATE_NOTE_SUCCESS: "CREATE_NOTE_SUCCESS",
    CREATE_NOTE_FAILURE: "CREATE_NOTE_FAILURE",

    FETCH_USER_NOTES_BEGIN: "FETCH_USER_NOTES_BEGIN",
    FETCH_USER_NOTES_SUCCESS: "FETCH_USER_NOTES_SUCCESS",
    FETCH_USER_NOTES_FAILURE: "FETCH_USER_NOTES_FAILURE",

    UPDATE_NOTE_BEGIN: "UPDATE_NOTE_BEGIN",
    UPDATE_NOTE_SUCCESS: "UPDATE_NOTE_SUCCESS",
    UPDATE_NOTE_FAILURE: "UPDATE_NOTE_FAILURE",

    DELETE_NOTE_BEGIN: "DELETE_NOTE_BEGIN",
    DELETE_NOTE_SUCCESS: "DELETE_NOTE_SUCCESS",
    DELETE_NOTE_FAILURE: "DELETE_NOTE_FAILURE",

    CLEAR_NOTE_RESPONSE: "CLEAR_NOTE_RESPONSE"
};

export default NOTES_TYPES;
